var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncreaseYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 -10 20 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8066 15.3203H21V17.7812H14.8066V15.3203Z",
    fill: "url(#paint0_linear_2949_3049)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8066 19.0117H21V21.4727H14.8066V19.0117Z",
    fill: "url(#paint1_linear_2949_3049)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8066 11.6289H21V14.0898H14.8066V11.6289Z",
    fill: "url(#paint2_linear_2949_3049)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.44531 12.9233L2.59157 12.9143L2.53809 11.6868C7.10546 11.2416 11.2085 8.70435 13.6411 4.85495L12.162 4.16461L17.7225 0.783203L18.7066 7.21732L16.9943 6.41883C15.8257 8.17139 13.9403 10.3187 11.2271 11.4801C8.43991 12.6727 5.45684 12.9233 3.44531 12.9233Z",
    fill: "url(#paint3_linear_2949_3049)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19336 21.4727H0V19.0117H6.19336V21.4727Z",
    fill: "url(#paint4_linear_2949_3049)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42383 15.3203H13.5762V17.7812H7.42383V15.3203Z",
    fill: "url(#paint5_linear_2949_3049)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42383 19.0117H13.5762V21.4727H7.42383V19.0117Z",
    fill: "url(#paint6_linear_2949_3049)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2949_3049",
    x1: 16.2396,
    y1: 16.7117,
    x2: 20.9555,
    y2: 16.7089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2949_3049",
    x1: 16.2396,
    y1: 20.4031,
    x2: 20.9555,
    y2: 20.4003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2949_3049",
    x1: 16.2396,
    y1: 13.0203,
    x2: 20.9555,
    y2: 13.0174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2949_3049",
    x1: 6.27896,
    y1: 7.64709,
    x2: 18.5904,
    y2: 7.64315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2949_3049",
    x1: 1.43294,
    y1: 20.4031,
    x2: 6.14885,
    y2: 20.4003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2949_3049",
    x1: 8.84728,
    y1: 16.7117,
    x2: 13.532,
    y2: 16.7089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2949_3049",
    x1: 8.84728,
    y1: 20.4031,
    x2: 13.532,
    y2: 20.4003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseYellow);
export default __webpack_public_path__ + "static/media/increase-yellow.37993ed698bf69e032fc8fab25a32c7a.svg";
export { ForwardRef as ReactComponent };